import { Typography } from 'antd';
import type { TitleProps } from 'antd/es/typography/Title';
import type { ReactNode } from 'react';
import cs from 'classnames';

interface PageHeaderProps {
    title: ReactNode;
    description?: ReactNode;
    className?: string;
    titleProps?: TitleProps;
}

export default function PageHeader({ title, description, className, titleProps }: PageHeaderProps) {
    return (
        <div className={cs('mb-6', className)}>
            <Typography.Title
                level={2}
                className="mb-2! mt-0!"
                {...titleProps}
            >
                {title}
            </Typography.Title>
            {description && <Typography.Text type="secondary">{description}</Typography.Text>}
        </div>
    );
}
